<a class=" button shadow-box" [ngClass]="class" (click)='navigate()'>
    <ng-content></ng-content>
</a>
